<template>
  <div>
    <div class="go-back">
      <el-page-header @back="goBack" content="会员详情" />
    </div>
    <div class="page-class">
      <div class="head">
        <div class="left">
          <div class="demo-type">
            <el-avatar :size="80" src="https://empty">
              <img :src="listData.headimgurl" />
            </el-avatar>
          </div>
        </div>
        <div class="right">{{ listData.nickname }}</div>
      </div>
      <div class="body">
        <div class="left">
          <div class="item">
            <div class="left">用户名称</div>
            <div class="right">{{ listData.name }}</div>
          </div>
          <div class="item">
            <div class="left">手机号</div>
            <div class="right">{{ listData.mobile }}</div>
          </div>
          <div class="item">
            <div class="left">身份证号</div>
            <div class="right">{{ listData.idcard }}</div>
          </div>
          <div class="item">
            <div class="left">用户类型</div>
            <div class="right">{{ isType("type", listData.type) }}</div>
          </div>
          <div class="item">
            <div class="left">会员等级</div>
            <div class="right">{{ isType("level", listData.level) }}</div>
          </div>
          <div class="item">
            <div class="left">所属分组</div>
            <div class="right">{{ isType("group_id", listData.group_id) }}</div>
          </div>
        </div>
        <div class="right">
          <div class="item">
            <div class="left">会员编号(导游编号)</div>
            <div class="right">{{ listData.coding }}</div>
          </div>

          <div class="item">
            <div class="left">openid</div>
            <div class="right">{{ listData.openid }}</div>
          </div>
          <div class="item">
            <div class="left">余额</div>
            <div class="right">{{ listData.balance }}</div>
          </div>
          <div class="item">
            <div class="left">分销人员</div>
            <div class="right">{{ isType("is_share", listData.is_share) }}</div>
          </div>
          <div class="item">
            <div class="left">创建时间</div>
            <div class="right">{{ listData.create_time }}</div>
          </div>
          <div class="item">
            <div class="left">跟新时间</div>
            <div class="right">{{ listData.update_time }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="item">
      <div class="left">用户名称</div>
      <div class="right">{{ listData.name }}</div>
    </div>
    <div class="item">
      <div class="left">手机号</div>
      <div class="right">{{ listData.mobile }}</div>
    </div>
    <div class="item">
      <div class="left">身份证号</div>
      <div class="right">{{ listData.idcard }}</div>
    </div>
    <div class="item">
      <div class="left">用户类型</div>
      <div class="right">{{ isType("type", listData.type) }}</div>
    </div>
    <div class="item">
      <div class="left">会员等级</div>
      <div class="right">{{ isType("level", listData.level) }}</div>
    </div>
    <div class="item">
      <div class="left">所属分组</div>
      <div class="right">{{ isType("group_id", listData.group_id) }}</div>
    </div>
    <div class="item">
      <div class="left">会员编号(导游编号)</div>
      <div class="right">{{ listData.coding }}</div>
    </div>

    <div class="item">
      <div class="left">openid</div>
      <div class="right">{{ listData.openid }}</div>
    </div>
    <div class="item">
      <div class="left">余额</div>
      <div class="right">{{ listData.balance }}</div>
    </div>
    <div class="item">
      <div class="left">分销人员</div>
      <div class="right">{{ isType("is_share", listData.is_share) }}</div>
    </div>
    <div class="item">
      <div class="left">创建时间</div>
      <div class="right">{{ listData.create_time }}</div>
    </div>
    <div class="item">
      <div class="left">跟新时间</div>
      <div class="right">{{ listData.update_time }}</div>
    </div> -->
    </div>
  </div>
</template>
<script>
import * as member from "@/api/product/member.js";
import * as userGroup from "@/api/product/user-group.js";
export default {
  data() {
    return {
      id: this.$route.query.id,
      listData: {},
      typeList: {
        level: [
          {
            text: "普通会员",
            value: 1
          },
          {
            text: "正式会员",
            value: 2
          },
          {
            text: "付费会员",
            value: 3
          }
        ],
        type: [
          {
            text: "普通用户",
            value: 1
          },
          {
            text: "会员用户",
            value: 2
          },
          {
            text: "分销商用户",
            value: 3
          }
        ],
        is_share: [
          {
            text: "限制使用",
            value: -1
          },
          {
            text: "正常",
            value: 1
          },
          {
            text: "未提交注册信息",
            value: 2
          },
          {
            text: "待审核注册信息",
            value: 3
          },
          {
            text: "审核成功",
            value: 4
          },
          {
            text: "审核失败",
            value: 5
          }
        ],
        group_id: []
      }
    };
  },
  created() {
    this.getInfo();
    userGroup.deleteUserGroupAll.r().then(res => {
      this.typeList.group_id = res;
    });
  },
  methods: {
    isType(type, id) {
      //   dataList[type].length
      let arr = this.typeList[type];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].value === id) return arr[i].text;
      }
    },
    getInfo() {
      member.getMemberInfo.r({ id: this.$route.query.id }).then(res => {
        this.listData = res;
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-class {
  width: 80%;
  // max-width: ;
  min-width: 800px;
  margin: 0 auto;
  // min-height: 100vh;
}
.head {
  display: flex;
  justify-content: center;
  line-height: 100px;
  .right {
    width: 40%;
    text-align: center;
    font-size: 20px;
  }
}
.go-back {
  position: -webkit-sticky; /* safari 浏览器 */
  position: sticky; /* 其他浏览器 */
  top: 0px;
  z-index: 9999;
  background-color: #fff;
}
.body {
  margin-top: 10px;
  display: flex;
  .left {
    width: 50%;
  }
  .right {
    width: 50%;
  }
}
.item {
  display: flex;
  line-height: 35px;
  font-size: 15px;
  &:nth-child(1) {
    border-top: 1px solid #dcdfe6;
  }
  border-bottom: 1px solid #dcdfe6;
  .left {
    font-size: 13px;
    font-weight: 500;
    padding-left: 10px;
    margin-right: 10px;
    color: #909399;
    width: 150px;
    background-color: #f7f7f7;
  }
  .right {
    width: calc(100% - 210px);
    color: #303133;
  }
}
</style>
